var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ketchConsentAdapter } from './ketch.js';
import { shopifyConsentAdapter } from './shopify.js';
export const addCdpConsent = (options) => {
    let adapter;
    /**
     * Returns the adapter for the specified consent management platform.
     */
    const getAdapter = () => {
        var _a;
        switch ((_a = options.consent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
            case 'ketch':
                return ketchConsentAdapter();
            case 'shopify':
                return shopifyConsentAdapter();
            default:
                return null;
        }
    };
    /**
     * Returns whether the CDP should be loaded based on the current consent.
     */
    const shouldLoadCdp = () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (adapter === null || adapter === void 0 ? void 0 : adapter.userCanBeTracked()) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, 500);
        });
    });
    /**
     * Updates consent for all future events.
     */
    const updateCdpConsent = (updatedConsent) => {
        const cdp = window[`_${options.namespace}`];
        if (cdp && typeof cdp.configure === 'function') {
            cdp.configure({ privacy: updatedConsent });
        }
        else {
            // CDP has not yet loaded via the snippet.
            window.jitsuConfig = { privacy: updatedConsent };
        }
    };
    /**
     * Adds consent management by setting defaults and handling changes.
     */
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        adapter = getAdapter();
        if (adapter === null)
            return Promise.resolve(false);
        yield shouldLoadCdp();
        updateCdpConsent(adapter === null || adapter === void 0 ? void 0 : adapter.getCurrentConsent());
        adapter === null || adapter === void 0 ? void 0 : adapter.handleConsentUpdates(updateCdpConsent);
        return Promise.resolve(true);
    });
    return {
        init,
    };
};
